var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"check-button  mr-2 rounded  outline-0 px-1 text-white fas  \n     d-flex align-items-center justify-content-center",class:(_vm.value?'bg-pri-light  fa-check border-0':'bg-white border-gray ')+' '+
     (_vm.large?'large':''),on:{"click":function($event){return _vm.$emit('input',!_vm.value)}}})}
var staticRenderFns = []

export { render, staticRenderFns }